import type {StateCreator} from 'zustand'

export interface ConfigOpts {
  forceUnifiedView: boolean
  useChangeGroups: boolean
  useInlineComments: boolean
  useEditOptions: boolean
  useFileTree: boolean
  useAdvancedToolbar: boolean
  useBasicToolbar: boolean
  userCanComment: boolean
  treeCollapsedByDefault: boolean
  treeEnableInlineCompactMode: boolean
}

export interface ConfigOptsSlice {
  configOpts: ConfigOpts
  configOptsActions: {
    updateConfigOpts: (opts: Partial<ConfigOpts>) => void
  }
}

export interface ConfigOptsSliceOpts {
  configOpts: ConfigOpts
}

export const createConfigOptsSlice =
  ({
    configOpts,
  }: ConfigOptsSliceOpts): StateCreator<ConfigOptsSlice, [['zustand/devtools', never]], [], ConfigOptsSlice> =>
  set => ({
    configOpts,
    configOptsActions: {
      updateConfigOpts: (updatedOpts: Partial<ConfigOpts>) => {
        set(state => ({
          configOpts: {
            ...state.configOpts,
            ...updatedOpts,
          },
        }))
      },
    },
  })
